import { render, staticRenderFns } from "./dSocialNetsBar.vue?vue&type=template&id=15a31c3e&"
import script from "./dSocialNetsBar.vue?vue&type=script&lang=js&"
export * from "./dSocialNetsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports